import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { PageHeaderComponent } from '../../../shared/components/ui/page-header/page-header.component';
import { toErrorMessage } from '../../../shared/helpers/http-error';
import { RolesService } from '../../../shared/services/roles.service';
import {
  RoleFormComponent,
  RoleFormPayload,
} from '../role-form/role-form.component';

@Component({
  selector: 'app-role-create',
  imports: [CommonModule, RouterModule, RoleFormComponent, PageHeaderComponent],
  templateUrl: './role-create.component.html',
})
export class RoleCreateComponent {
  private readonly rolesService = inject(RolesService);
  private readonly router = inject(Router);

  readonly submitting = signal(false);
  readonly serverError = signal<string | null>(null);

  onSave(payload: RoleFormPayload): void {
    this.submitting.set(true);
    this.serverError.set(null);
    this.rolesService.create(payload).subscribe({
      next: (created) => {
        this.submitting.set(false);
        void this.router.navigate(['/roles', created.name]);
      },
      error: (err: unknown) => {
        this.submitting.set(false);
        this.serverError.set(
          toErrorMessage(err, 'La création a échoué.', {
            409: 'Un rôle avec ce nom existe déjà.',
          }),
        );
      },
    });
  }

  onCancel(): void { void this.router.navigate(['/roles']); }
}
